









import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { IInputRuleBehavior, InputRuleKinds } from "../../../../../documaker/domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class InputRuleBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IInputRuleBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IInputRuleBehavior) => T, defaultValue: T) => T;

  get kind(): InputRuleKinds {
    return this.readPropertyOrDefault(s => s.kind, InputRuleKinds.None);
  }

  set kind(value: InputRuleKinds) {
    this.writePropertyWhenValid(s => s.kind = value);
  }

  kindOptions: StandardOption<number>[] = [
    new StandardOption<number>("全て許可", InputRuleKinds.None),
    new StandardOption<number>("全角", InputRuleKinds.FullWidthOnly),
    new StandardOption<number>("全角カナ", InputRuleKinds.FullWidthKanaOnly),
    new StandardOption<number>("半角カナ", InputRuleKinds.HalfWidthKanaOnly),
    new StandardOption<number>("半角数字", InputRuleKinds.HalfWidthNumberOnly),
    new StandardOption<number>("半角英数記号", InputRuleKinds.HalfWidthAlphabetAndNumberOnly),
  ];
}
